// src/components/Legal/PrivacyPolicy.js

import React from "react";
import "../../styles/ijrr.css";

export default function PrivacyPolicy() {
    return (
        <section className="privacy-policy-section space-pb-80">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">

                    <h2 className="original-title text-center mb-4 golden">Privacy Policy</h2>

<p className="ijrr-text">
  This Privacy Policy outlines how the International Jolly Roger Registry (IJRR) collects, uses, and protects your personal information. By using our website or services, you consent to the practices described in this policy. Our mission is to empower members with tools to build a personal brand while respecting and safeguarding their privacy.
</p>

<br />

<h4 className="ijrr-title">1. Information We Collect</h4>
<p className="ijrr-text">We collect personal information when you interact with our platform, including but not limited to:</p>
<ul className="ijrr-list">
  <li>Name, email address, and contact details</li>
  <li>Images or media uploaded to create your personal brand</li>
  <li>Billing and payment information for purchases</li>
  <li>Browser data such as IP address, cookies, and device type</li>
</ul>

<br />

<h4 className="ijrr-title">2. How We Use Your Information</h4>
<p className="ijrr-text">Your information helps us:</p>
<ul className="ijrr-list">
  <li>Provide and improve our services and personalized experiences</li>
  <li>Process membership registrations and product orders</li>
  <li>Send service updates, account alerts, or promotional emails</li>
  <li>Ensure security and prevent unauthorized access or fraud</li>
</ul>

<br />

<h4 className="ijrr-title">3. Sharing Your Data</h4>
<p className="ijrr-text">
  We do not sell, rent, or trade your personal information. We may share it with trusted partners or service providers solely to help us operate our platform—such as payment gateways, shipping services, or email platforms. All partners are required to comply with strict data protection standards.
</p>

<br />

<h4 className="ijrr-title">4. Cookies and Tracking Technologies</h4>
<p className="ijrr-text">
  We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, and serve you relevant content. You may disable cookies through your browser settings, though some features of our site may not function as intended without them.
</p>

<br />

<h4 className="ijrr-title">5. Data Retention</h4>
<p className="ijrr-text">
  We retain your personal data only as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, or resolve disputes. You may request deletion of your data at any time.
</p>

<br />

<h4 className="ijrr-title">6. Your Rights</h4>
<p className="ijrr-text">As a user, you have the right to:</p>
<ul className="ijrr-list">
  <li>Access the personal data we hold about you</li>
  <li>Request corrections to inaccurate data</li>
  <li>Withdraw consent or request deletion of your account</li>
  <li>Opt out of marketing communications</li>
</ul>
<p className="ijrr-text">
  Please contact us at <a href="mailto:info@myjollyroger.com" className="ijrr-link">info@myjollyroger.com</a> to exercise any of these rights.
</p>

<br />

<h4 className="ijrr-title">7. Data Security</h4>
<p className="ijrr-text">
  We implement technical and organizational measures to protect your personal data from unauthorized access, loss, or misuse. While no system is 100% secure, we work continuously to maintain the integrity of your data.
</p>

<br />

<h4 className="ijrr-title">8. International Transfers</h4>
<p className="ijrr-text">
  IJRR operates internationally. Your information may be transferred to, and stored in, countries outside your jurisdiction. We ensure all transfers comply with applicable data protection laws.
</p>

<br />

<h4 className="ijrr-title">9. Changes to This Policy</h4>
<p className="ijrr-text">
  We may occasionally update this Privacy Policy to reflect changes in our practices, technology, or legal requirements. All updates will be posted on this page with the effective date.
</p>

<br />

<h4 className="ijrr-title">10. Contact Us</h4>
<p className="ijrr-text">
  If you have any questions, concerns, or feedback regarding this Privacy Policy, please contact us at:
  <br />
  <strong>Email:</strong> <a href="mailto:info@myjollyroger.com" className="ijrr-link">info@myjollyroger.com</a>
</p>

<br />

<p className="ijrr-text text-center">
  Thank you for trusting the International Jolly Roger Registry. Your privacy is our priority.
</p>

                    </div>
                </div>
            </div>
        </section>
    );
}